import {SyncOutlined} from '@ant-design/icons'

export const LoadingIcon = ({size}: {size?: number}) => <SyncOutlined spin style={{fontSize: size}} />
